import React, { useState } from "react";

const useChildRegistration = () => {
  const [infoClicked, setInfoClicked] = useState(false);

  const handleInfoClicked = () => {
    setInfoClicked((prevState) => !prevState);
  };
  return {
    handleInfoClicked,
    infoClicked,
    setInfoClicked,
  };
};

export default useChildRegistration;
